'use client';

export function UpdateConsent() {
  const updateConsent = () => {
    if (typeof window !== 'undefined' && window?.JLG?.consent) {
      window.JLG.consent.updatePrivacyConsent();
    }
  };

  return (
    <span
      className="cursor-pointer"
      onClick={updateConsent}
      aria-label="Update Your Cookie Consent"
    >
      Update Your Cookie Consent
    </span>
  );
}

export default UpdateConsent;
